// Initializes Sentry on the web. Imported from main.tsx before app render.
// No-op when VITE_SENTRY_DSN is unset (local dev without Sentry).
import * as Sentry from '@sentry/react';

const dsn = import.meta.env.VITE_SENTRY_DSN;

if (dsn) {
  Sentry.init({
    dsn,
    // VITE_SENTRY_ENVIRONMENT is set per-branch in vite.config.ts from
    // CF_PAGES_BRANCH (develop → 'staging', main → 'production'). Falls back
    // to Vite's MODE for local dev / overrides.
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE,
    release: import.meta.env.VITE_RELEASE,
    integrations: [
      Sentry.browserTracingIntegration(),
      // Privacy by default: mask all user-visible text and media in replays.
      // We can selectively unmask later via data-sentry-unmask on safe elements.
      Sentry.replayIntegration({
        maskAllText: true,
        maskAllInputs: true,
        blockAllMedia: true,
      }),
    ],
    // Max instrumentation: replay every session + 100% of traces.
    // Bump down if we hit free-tier limits (Sentry web replay free tier: 50/mo).
    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0,
    tracesSampleRate: 1.0,
    sendDefaultPii: false,
    // Avoid shipping app log noise from production browsers.
    enableLogs: import.meta.env.MODE !== 'production',
  });
}

export { Sentry };
